function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 36h25l-2 19H17zM12 31h31v5H12zM21 31s-3.317-9.91-3-15c.196-3.156.68-6.851 3-9 2.017-1.868 5.314-2.586 8-2 2.085.455 3.97 2.13 5 4 1.456 2.644 1.063 5.982 1 9-.092 4.383-2 13-2 13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 21c-5 0-8-1-10-2-2.404-1.202-4.779-4.428-4-7 .432-1.427 2.51-1.938 4-2 3.587-.15 10 4 10 4M35 19s3.477-4.36 6-5c1.647-.418 3.77-.173 5 1 .995.948 1.367 2.676 1 4-.378 1.363-1.786 2.275-3 3-2.988 1.785-10 3-10 3M24 31c-2.07-12.148-2.706-23.281 2.1-26M30.1 31c.95-12.468 1.98-23.47-2.167-26M27 31V5M4 12c4.667-.635 9.333 2.788 14 4M4 13c2 4 14 5 14 5M35 21c3.667-1.753 7.333-5.848 11-6M34.6 23c13-5 11.8-7 11.8-7M29 2l-1 3M23 2l1 3M34 4l-2 3M37 8l-3 1M18.2 4.4L21 7M15 9l4 1"
}));

var SvgCactus = function SvgCactus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCactus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cactus.0a8d46a8.svg";
export { ForwardRef as ReactComponent };